import Vue from 'vue'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setServiceList(state, serviceList) {
    Vue.set(state, 'serviceList', serviceList)
  },
  setPhoneList(state, phoneList) {
    Vue.set(state, 'phoneList', phoneList)
  },
}



// WEBPACK FOOTER //
// ./src/store/hail/mutations.js